import { render, staticRenderFns } from "./ProductDetailCard.vue?vue&type=template&id=2d861517&"
import script from "./ProductDetailCard.vue?vue&type=script&lang=js&"
export * from "./ProductDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports